import { ParagraphTextRange } from 'src/models/Text'
import { TranscriptParagraph } from 'src/models/Transcript'
import { TranscriptClient } from 'src/models/TranscriptClient'

export const fuzzySearch = (transcript: TranscriptClient, searchTerm: string): ParagraphTextRange[] => {
    const results: ParagraphTextRange[] = []
    const normalizedSearchTerm = searchTerm.toLowerCase()

    for (let i = 0; i < transcript.getTotalParagraphCount(); i++) {
        const paragraph = transcript.getParagraphByIndex(i)
        const content = TranscriptParagraph.textOf(paragraph).toLowerCase()

        let foundIndex = content.indexOf(normalizedSearchTerm)

        while (foundIndex !== -1) {
            results.push({
                paragraphId: paragraph.id,
                start: foundIndex,
                end: foundIndex + normalizedSearchTerm.length,
            })

            foundIndex = content.indexOf(normalizedSearchTerm, foundIndex + 1)
        }
    }

    return results
}
